import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgOrelCardIpgComponent} from './ng-orel-card-ipg.component';
import {NgOrelCardIpgService} from './ng-orel-card-ipg.service';


@NgModule({
  declarations: [NgOrelCardIpgComponent],
  imports: [
    CommonModule
  ],
  exports: [NgOrelCardIpgComponent]
})
export class NgOrelCardIpgModule {
  public static forRoot(config): ModuleWithProviders<NgOrelCardIpgModule> {
    return {
      ngModule: NgOrelCardIpgModule,
      providers: [
        NgOrelCardIpgService,
        {provide: 'config', useValue: config}
      ]
    };
  }
}
